export default __webpack_public_path__ + "static/media/tkit-2.ae69f418.svg";